import { post } from '../utils/ApiUtil';
import type {
  CommentInfoDTO,
  DeliveryConfigOptionDTO,
  DeliveryItemDTO,
  OperationInfoDTO,
  SubmitDeliveryItemDTO,
} from './DeliveryType';

const mock = false;

export const DeliveryApi = {
  getDeliveryList(param: { finishDate: string }) {
    if (mock && false) return Promise.resolve([] as DeliveryItemDTO[]);
    return post<{ finishDate: string }, DeliveryItemDTO[]>('/sparrow/queryDelivery', param);
  },
  createDeliveryItem(param: SubmitDeliveryItemDTO) {
    if (mock && false) return Promise.resolve(true);
    return post<SubmitDeliveryItemDTO, boolean>('/sparrow/addDelivery', param);
  },
  updateDeliveryItems(param: { deliveryWeekTaskList: (SubmitDeliveryItemDTO & { id: number })[] }) {
    if (mock && false) return Promise.resolve(true);
    return post<typeof param, boolean>('/sparrow/updateDelivery', param);
  },
  deleteDeliveryItem(param: { id: number }) {
    if (mock && false) return Promise.resolve(true);
    return post<{ id: number }, boolean>('/sparrow/deleteDelivery', param);
  },
  getDeliveryConfigType(param: { deliveryConfigType: number }) {
    if (mock && false) return Promise.resolve([] as DeliveryConfigOptionDTO[]);
    return post<{ deliveryConfigType: number }, DeliveryConfigOptionDTO[]>(
      '/sparrow/queryDeliveryConfigType',
      param,
    );
  },
  createDeliveryConfigType(param: { type: number; name: string; orderNum: number }) {
    if (mock && false) return Promise.resolve(true);
    return post<typeof param, boolean>('/sparrow/addDeliveryConfigType', param);
  },
  updateDeliveryConfigType(param: { id: number; type: number; name: string; orderNum: number }) {
    if (mock && false) return Promise.resolve(true);
    return post<typeof param, boolean>('/sparrow/updateDeliveryConfigType', param);
  },
  deleteDeliveryConfigType(param: { type: number; id: number }) {
    if (mock && false) return Promise.resolve(true);
    return post<typeof param, boolean>('/sparrow/deleteDeliveryConfigType', param);
  },
  getOperationLogById(param: { taskId: number }) {
    if (mock && false) return Promise.resolve([] as OperationInfoDTO[]);
    return post<{ taskId: number }, OperationInfoDTO[]>('/sparrow/getTaskOperateLog', param);
  },
  addOrEditDeliveryLegacy(param: unknown) {
    if (mock && false) return Promise.resolve(0);
    return post<unknown, number>('/sparrow/delivery/addOrEdit', param);
  },
};
